import { defineComponent } from 'vue';
import { QList, QItem, QItemSection, QCheckbox } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

const MULTI_SELECT_LIST_CLICK_CODE_BEHIND = {
    handlerSuffix: '_Click',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your click handler here\n\t}`;
    },
};

const placeholderItems = ['Option A', 'Option B', 'Option C'];

export default defineComponent({
    name: 'multiselectlist-dsgn',
    mixins: [BaseComponentMixin],
    components: { QList, QItem, QItemSection, QCheckbox },
    computed: {
        containerStyle() {
            return {
                overflow: 'auto',
                ...utils.getSize(this.controlData?.SizeOptions, this.parentType, this.$parent),
                ...utils.getStyleHints(this.controlData?.StyleHints, this),
            };
        },
    },
    methods: {
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, MULTI_SELECT_LIST_CLICK_CODE_BEHIND);
        },
    },
    render() {
        if (!this.controlData)
            return null;

        const items = placeholderItems.map((label, i) => (
            <QItem key={i} class="q-px-sm q-py-xs">
                <QItemSection avatar>
                    <QCheckbox size="sm" disable modelValue={i === 0} />
                </QItemSection>
                <QItemSection>{label}</QItemSection>
            </QItem>
        ));

        return (
            <div
                class={{ 'MultiSelectList': true, 'designer-container': true, selected: this.selected$ }}
                style={this.containerStyle}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                <QList dense>{items}</QList>
            </div>
        );
    },
});
